import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import Adapter from 'customer-data-filters-ui/fetcher/adapter/adapters/Adapter';
import ObjectDefinitionsAdapterConfig from 'customer-data-filters-ui/fetcher/adapter/adapterConfigs/ObjectDefinitionsAdapterConfig';
export class StandardObjectDefinitionsAdapterConfig extends ObjectDefinitionsAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'StandardObjectDefinitionsAdapter';
  }
  getCacheKey() {
    return 'STANDARD_OBJECT_DEFINITIONS';
  }
  includeObject(objectDefinition) {
    const {
      metaType
    } = objectDefinition;
    return metaType === 'HUBSPOT';
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.STANDARD_OBJECT_DEFINITION;
  }
}
export default Adapter.makeFromConfig(StandardObjectDefinitionsAdapterConfig);